import { Component, OnInit, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { I18NextAdapterPipe, I18nService } from '@pflegix/i18n';
import { BusinessPartnerResponseDto } from '@pflegix/types';
import {
  AppIconService,
  ConfirmationDialogService,
  EntityHeaderComponent,
  SidebarWithConfirmationComponent,
} from '@pflegix/ui';
import { AddressUtilService } from '@pflegix/util';
import { ConfirmationService } from 'primeng/api';
import { OverviewViewComponent } from '../../../view/root/children/business-partner-center/children/overview/overview-view.component';
import { BusinessPartnerHeaderDataComponent } from '../business-partner-header-data/business-partner-header-data.component';
import { BusinessPartnerStore } from '../store';
import { BUSINESS_PARTNER_SIDEBAR_NAMESPACE } from './i18n/business-partner-sidebar-namespace.const';
import { BUSINESS_PARTNER_SIDEBAR_TRANSLATION_DE } from './i18n/de/business-partner-sidebar.translation.de';
import { BUSINESS_PARTNER_SIDEBAR_TRANSLATION_EN } from './i18n/en/business-partner-sidebar.translation.en';

@Component({
  selector: 'pfx-business-partner-sidebar',
  imports: [
    SidebarWithConfirmationComponent,
    BusinessPartnerHeaderDataComponent,
    OverviewViewComponent,
    EntityHeaderComponent,
    RouterLink,
    I18NextAdapterPipe,
  ],
  providers: [ConfirmationDialogService, ConfirmationService],
  templateUrl: './business-partner-sidebar.component.html',
})
export class BusinessPartnerSidebarComponent extends SidebarWithConfirmationComponent implements OnInit {
  public businessPartnerId = input.required<string>();

  protected businessPartnerIcon = computed<IconDefinition | undefined>(() => {
    const businessPartner = this.businessPartner();

    const appIcon = !businessPartner
      ? this.appIconService.getBusinessPartnerIcon()
      : this.appIconService.getBusinessPartnerIconByType(businessPartner.type, {
          // todo: determine if business partner has order
          hasOrder: true,
        });

    if (!appIcon) {
      return undefined;
    }

    return appIcon.icon;
  });

  protected i18nNamespace = BUSINESS_PARTNER_SIDEBAR_NAMESPACE;

  private businessPartnerStore = inject(BusinessPartnerStore);

  private businessPartner = computed<BusinessPartnerResponseDto | undefined>(
    () => this.businessPartnerStore.entityMap()[this.businessPartnerId() ?? '']
  );

  protected businessPartnerType = computed(() => {
    const businessPartner = this.businessPartner();

    return businessPartner ? businessPartner.type : '';
  });

  protected title = computed(() => {
    const businessPartner = this.businessPartner();

    return businessPartner ? AddressUtilService.generateNameReverse(businessPartner.mainAddress) : '';
  });

  private readonly i18n = inject(I18nService);

  private readonly appIconService = inject(AppIconService);

  constructor() {
    super();

    this.i18n.addTranslations({
      namespace: BUSINESS_PARTNER_SIDEBAR_NAMESPACE,
      de: BUSINESS_PARTNER_SIDEBAR_TRANSLATION_DE,
      en: BUSINESS_PARTNER_SIDEBAR_TRANSLATION_EN,
    });
  }

  public ngOnInit(): void {
    this.businessPartnerStore.loadById(this.businessPartnerId());
  }
}
